import { render, staticRenderFns } from "./AvailableForKauLoggedInUser.vue?vue&type=template&id=b143603a&scoped=true"
import script from "./AvailableForKauLoggedInUser.vue?vue&type=script&lang=js"
export * from "./AvailableForKauLoggedInUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143603a",
  null
  
)

export default component.exports